const linkDomain = import.meta.env.VITE_APP_LINK_DOMAIN
  ? new URL(import.meta.env.VITE_APP_LINK_DOMAIN).hostname
  : null;

export const IS_ME_LINK =
  linkDomain !== null && window.location.hostname === linkDomain;

export const LANDING_URL = import.meta.env.VITE_APP_LINK_LANDING;
